import React from 'react';
import { ISideBar } from '../interfaces';
import Button from '../../../generic-components/Button';
import { STYLES } from '../consts';

const { SIDE_BAR: { WRAPPER, BUTTON, INDICATOR } } = STYLES;

export const YearsSelector = ({ yearsList, activeYear, handleYearSelection }: ISideBar) => (
  <div className={WRAPPER}>
    {yearsList.map(y => (
      <React.Fragment key={y}>
        <Button onClick={() => handleYearSelection(y)} childElement={<div className={`${INDICATOR} ${activeYear === y ? '' : 'hidden'}`} />} className={BUTTON} title={y.toString()} id={`year-${y}`} />
      </React.Fragment>
    ))}
  </div>
);
